import { Text } from '@shopify/polaris';
import { IntegrationAdapter, IntegrationConfig } from '../../types';
import IntegrationCard from '../IntegrationCard';
import { StyledIntegrationList } from './styled';

interface IntegrationListProps {
  items: IntegrationConfig[];
  adaptersById: Record<string, IntegrationAdapter>;
  onOpenPanel: (id: string) => void;
}

const IntegrationList = ({ items, adaptersById, onOpenPanel }: IntegrationListProps) => {
  if (items.length === 0) {
    return (
      <StyledIntegrationList>
        <Text as="p" tone="subdued">
          No apps match your search.
        </Text>
      </StyledIntegrationList>
    );
  }

  return (
    <StyledIntegrationList>
      {items.map((config) => {
        const adapter = config.connectable ? adaptersById[config.id] : undefined;
        return (
          <IntegrationCard
            key={config.id}
            config={config}
            status={adapter?.status}
            isFetching={adapter?.isFetching}
            onOpenPanel={() => onOpenPanel(config.id)}
          />
        );
      })}
    </StyledIntegrationList>
  );
};

export default IntegrationList;
